// jquery
import 'script!uglify!jquery';
// migrate (min is muted version)
import 'script!./../node_modules/jquery-migrate/dist/jquery-migrate.min';
// ui
import 'script!./../client-side/JqueryUI/jquery-ui.min';
import './../client-side/JqueryUI/jquery-ui.min.css';
// ui touch devices fix
import 'script!./../client-side/common/js/jquery.ui.touch-punch.min';
// chosen
import 'script!uglify!./../client-side/Chosen/chosen.jquery';
import './../client-side/Chosen/bootstrap-chosen.css';
// moment (working with dates)
import 'script!uglify!./../node_modules/moment/min/moment-with-locales.min';
// bootstrap
import 'script!uglify!./../node_modules/bootstrap/dist/js/bootstrap';
// file input
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/fileinput';
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/locales/cs';
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/locales/sk';
import './../node_modules/bootstrap-fileinput/css/fileinput.css';
// eonasdan bootstrap datetimepicker
import 'script!uglify!eonasdan-bootstrap-datetimepicker';
import './../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
// daterangepicker
import 'script!uglify!bootstrap-daterangepicker';
import './../node_modules/bootstrap-daterangepicker/daterangepicker.css';
// bootstrap-select
import 'script!uglify!bootstrap-select';
import './../node_modules/bootstrap-select/less/bootstrap-select.less';
// ajax-bootstrap-select
import 'script!uglify!ajax-bootstrap-select';
import './../node_modules/ajax-bootstrap-select/src/less/styles.less';
// nette
import 'script!uglify!./../bin/vendor/nette/forms/src/assets/netteForms';
import 'script!uglify!./Nette/nette.ajax.js';

// ffs
import FSRibbon from './Ribbon/js/ribbon';
import FSForms from './Form/js/fsForms';
import FSGridSnippet from './GridSnippet/js/grid';
import './../client-side/common/less/main.less';
import './../client-side/common/less/responsive.less';
import 'script!uglify!./../client-side/common/js/responsive';
import 'script!uglify!./../client-side/Form/js/formValidation';
import MetadataLogicConfigurator from './MetadataLogic/MetadataLogicConfigurator';
import './../client-side/Tree/css/tree_css.css';

// init
$(function()
{
  // check fot duplicite init
  if (window.FSForms){
    console.log('%c FormFlow ERROR! Duplicite loading of JS, probably by AJAX!', 'background: red; color: white');
    return;
  }

  // check jquery version
  if (jQuery.fn.jquery != "3.6.0"){
    console.log('%c jQuery ERROR! FormFlow needs jQuery v3.6.0!', 'background: red; color: white');
    return;
  }

  // initialization components
  $.nette.init();
  FSForms.init();
  FSGridSnippet.initAll();
  FSRibbon.init();
  MetadataLogicConfigurator.createDocumentControlsInit();
  MetadataLogicConfigurator.singleEditDocumentControlsInit();
  MetadataLogicConfigurator.bulkEditDocumentsControlsInit();

  // fs csrf ajax protection
  XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(){
    this.origOpen.apply(this, arguments);
    this.setRequestHeader('x-fs-token', $('#fs_token').val());
    this.addEventListener('load', function(event){
      if (this.responseText && this.responseText.substring(0,1) == '{' && this.responseText.indexOf('invalidCsrf') !== -1){
        var result = jQuery.parseJSON(this.responseText);
        if (result.reason == 'invalidCsrf' && result.message){
          event.stopImmediatePropagation();
          event.preventDefault();
          waiter_close();
          alert(result.message);
        }
      }
    });
  };

  // set global properties
  window.FSForms = FSForms;
  window.FSGridSnippet = FSGridSnippet;
  window.TracyMaxAjaxRows = 2;

  $(document).ajaxComplete(() => {
    setTimeout(function(){
      MetadataLogicConfigurator.createDocumentControlsInit();
      MetadataLogicConfigurator.singleEditDocumentControlsInit();
      MetadataLogicConfigurator.bulkEditDocumentsControlsInit();
    }, 10);
  });

  // unlock gui (preventing clicks when js is not ready)
  $('body').removeClass('not-active');

  // XMLGW_PERFORMANCE_API_ALERT
  if ($('#performance_api_alert').val()){
    let load = (window.performance.timing.responseEnd - window.performance.timing.navigationStart) / 1000;
    let total = window.performance.now() / 1000;
    let render = total - load;
    alert('FFS: [L: '+ load.toFixed(2) + ', R: ' + render.toFixed(2) + ', T: ' + total.toFixed(2) + ']');
  }
});




// WEBPACK FOOTER //
// ./client-side/bootstrap.js